import React from 'react';
import TopFooter from './Topfooter';

// JSON & Styles
import { makeStyles } from '@material-ui/core/styles';

const Footer = () => {
  //   const useStyles = makeStyles({
  //     container: {
  //       marginTop: '190px',
  //     },
  //   });
  //   const classes = useStyles();
  return (
    <div>
      <TopFooter />
    </div>
  );
};

export default Footer;
